import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import P from 'prop-types';

import { withAuth, loginType } from '../../../contexts/AuthContext';

const ProtectedRoute = props => {
   const { auth, allowedLoginTypes = Object.values(loginType), ...rest } = props;
   return auth.user && allowedLoginTypes.includes(auth.user.loginType) ? (
      <Route {...rest} />
   ) : (
      <Redirect to="/" />
   );
};

ProtectedRoute.propTypes = {
   auth: P.object,
   allowedLoginTypes: P.arrayOf(P.string)
};

export default withAuth(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/UI/components/ProtectedRoute/ProtectedRoute.js